module.exports = __webpack_public_path__ + "img/acidwash.8d1ef629.jpg";